import { Grid, styled } from "@mui/material";

export const StyledContainer = styled(Grid)({
  textAlign: "center",
  gap: "24px",
});
